<script setup lang="ts">
import { X, Settings, MessageSquare, ExternalLink, User, MoreVertical } from 'lucide-vue-next';
import brandLogo from '@/assets/logo-brand.svg';

const props = defineProps<{
  showInsightModal: boolean;
  showSharePreview: boolean;
}>();
</script>

<template>
  <div class="bet-card-state-container">
    <!-- APP HEADER -->
    <header v-if="!showInsightModal && !showSharePreview" class="app-header-main">
      <div class="header-inner">
        <div class="brand-logo-container">
          <img :src="brandLogo" alt="BetPic" class="brand-img" />
        </div>
        <div class="header-actions">
          <div class="user-pill"><User :size="16" /></div>
          <div class="more-btn"><MoreVertical :size="18" /></div>
        </div>
      </div>
    </header>

    <div class="scroller-content animate-in">
      <div class="search-box-filled">
        <span>Arsenal Liverpool</span>
        <X :size="16" class="text-gray-500" />
      </div>
      <div class="bet-card-main">
        <div class="card-header-red">Bet (2 selections)</div>
        <div class="card-body">
          <div class="leg-group">
            <div class="leg-meta">Arsenal v Burnley</div>
            <div class="leg-submeta">Mon 18th 20:00 • Premier League</div>
            <div class="leg-main"><div class="leg-sel"><span class="sel-name">Arsenal</span><span class="sel-mkt">Match Odds</span></div><div class="leg-price">@1.08</div></div>
          </div>
          <div class="leg-group border-t border-white/5 pt-3">
            <div class="leg-meta">Aston Villa v Liverpool</div>
            <div class="leg-submeta">Fri 20:00 • Premier League</div>
            <div class="leg-main"><div class="leg-sel"><span class="sel-name">Liverpool</span><span class="sel-mkt">Match Odds</span></div><div class="leg-price">@2.15</div></div>
          </div>
          <div class="card-footer-btns"><div class="c-btn-red"><Settings :size="16" /></div><div class="c-btn-red ml-auto"><MessageSquare :size="16" /></div></div>
        </div>
      </div>
    </div>

    <!-- Move Dock Footer Outside Scroller -->
    <div class="bet-dock-footer">
      <span class="d-total-odds">@2.33</span>
      <div class="d-go-btn">Go <ExternalLink :size="14" /></div>
      <div class="d-share-btn"><span class="logo-bet-s">bet</span><span class="logo-pic-s">Pic</span></div>
    </div>
  </div>
</template>

<style scoped>
.bet-card-state-container { display: flex; flex-direction: column; height: 100%; width: 100%; position: relative; }
.app-header-main { padding: 4px 12px; height: 46px; z-index: 50; }
.header-inner { display: flex; justify-content: space-between; align-items: center; height: 100%; }
.brand-logo-container { display: flex; align-items: center; }
.brand-img { height: 20px; width: auto; object-fit: contain; }
.header-actions { display: flex; align-items: center; gap: 8px; }
.user-pill { width: 28px; height: 28px; background: #e21b0d; border-radius: 50%; color: #fff; display: flex; align-items: center; justify-content: center; }
.more-btn { color: #fff; display: flex; align-items: center; }

.scroller-content { flex: 1; padding: 10px; display: flex; flex-direction: column; gap: 10px; overflow-y: auto; }
.search-box-filled { background: #0c0c0e; border-radius: 100px; padding: 8px 14px; border: 1px solid #1a1a1c; color: #fff; font-size: 12px; display: flex; justify-content: space-between; align-items: center; }

.bet-card-main { background: #111113; border-radius: 12px; border: 1px solid rgba(255,255,255,0.1); overflow: hidden; }
.card-header-red { background: #e21b0d; padding: 5px 12px; color: #fff; font-size: 10px; font-weight: 700; }
.card-body { padding: 10px; display: flex; flex-direction: column; gap: 8px; }
.leg-group { display: flex; flex-direction: column; gap: 2px; }
.leg-meta { font-size: 11px; font-weight: 700; color: #fff; }
.leg-submeta { font-size: 9px; color: #777; }
.leg-main { display: flex; justify-content: space-between; align-items: flex-end; }
.leg-sel { display: flex; flex-direction: column; }
.sel-name { color: #fff; font-weight: 700; font-size: 12px; }
.sel-mkt { color: #777; font-size: 9px; font-weight: 500; }
.leg-price { color: #aaa; font-weight: 800; font-size: 10px; background: rgba(255,255,255,0.05); padding: 5px 8px; border-radius: 4px; border-left: 1px solid rgba(255,255,255,0.1); }
.card-footer-btns { display: flex; gap: 8px; padding-top: 4px; }
.c-btn-red { width: 28px; height: 28px; background: #e21b0d; border-radius: 50%; color: #fff; display: flex; align-items: center; justify-content: center; }

.bet-dock-footer { 
  position: absolute; bottom: 10px; left: 10px; right: 10px; 
  background: #1a1a1c; border: 1px solid #333; border-radius: 100px; 
  padding: 5px 6px; display: flex; align-items: center; justify-content: space-between; 
  box-shadow: 0 10px 30px rgba(0,0,0,0.5); 
  z-index: 100;
}
.d-total-odds { color: #fff; font-weight: 800; font-size: 14px; padding-left: 8px; }
.d-go-btn { background: #fff; color: #000; padding: 5px 12px; border-radius: 100px; font-weight: 700; font-size: 11px; display: flex; align-items: center; gap: 5px; }
.d-share-btn { background: #fff; color: #000; border-radius: 100px; padding: 4px 10px; display: flex; align-items: center; }
.logo-bet-s { font-weight: 900; font-size: 13px; color: #777; letter-spacing: -1px; }
.logo-pic-s { font-weight: 900; font-size: 13px; color: #e21b0d; letter-spacing: -1px; }

.animate-in { animation: fadeInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
</style>
